export const cs = {
  Global: {
    save: 'Uložit',
    savingInProgress: 'Saving in progress CS',
    edit: 'Upravit',
    amend: 'Amend CS',
    editProposal: 'Edit proposal CS',
    delete: 'vymazat',
    cancel: 'zrušit',
    confirm: 'Potvrdit',
    proceed: 'Pokračovat',
    assign: 'Přiřadit',
    submit: 'Předložit',
    accepted: 'přijato',
    denied: 'popřít',
    deny: 'Odmítnout',
    done: 'Hotovo',
    notDone: 'Neudělané',
    comment: 'Komentář',
    started: 'Začal',
    notRelevant: 'Irelevantní',
    noInfo: 'Žádné informace',
    addComment: 'Přidat komentář',
    noComments: 'Bez komentáře',
    start: 'Počáteční datum',
    end: 'Datum ukončení',
    pending: 'čekající',
    approve: 'Schvalovat',
    approved: 'Schváleno',
    notApproved: 'Neschváleno',
    release: 'Uvolnění',
    released: 'uvolněno',
    notReleased: 'Nevydáno',
    reopen: 'Znovu otevřít',
    requestedBy: 'požadováno',
    requestedAt: 'požádáno',
    proposedDecision: 'navrhované rozhodnutí',
    proposedCategory: 'navrhované kategorie',
    proposedSubcategory: 'Proposed subcategory',
    search: 'Vyhledávání',
    noResults: 'Žádné výsledky',
    upload: 'nahrát',
    uploading: 'Nahrávání',
    noFilesUploaded: 'Nebyly nahrány žádné soubory',
    close: 'Zavřít',
    back: 'Zadní',
    next: 'další',
    unknown: 'neznámý',
    from: 'z',
    to: 'na',
    logout: 'Odhlásit se',
    profile: 'Profil',
    group: 'Skupina',
    code: 'Kód',
    confirmationDialogTitle: 'potvrzení potřebovalo',
    confirmDeleteFileDialogContent: 'Jste si jisti, že chcete smazat tento soubor?',
    report: 'zpráva',
    unsavedAnswers: 'Máte neuložené odpovědi. Potvrzením ztratíte všechna neuložená data.',
    unsavedAnswersActionMode: 'Máte neuložené odpovědi. Chcete je uložit?',
    noOptions: 'žádné volby',
    actionMode: 'Režim Action',
    reason: 'Důvod',
    optional: 'volitelný',
    choose: 'Vybrat',
    serialNumberMissing: 'Serial number missing CS',
    recipientEmails: 'Recipient Emails (one address per line) CS',
    DatePicker: {
      cancelLabel: 'zrušit',
      okLabel: 'OK',
      minDateMessage: 'Datum by nemělo být dříve než 1. ledna 1900',
      maxDateMessage: 'Datum by nemělo být dnes',
      invalidDateMessage: 'Neplatný formát data',
    },
    Errors: {
      authErrorTitle: 'Chyba ověření!',
      authErrorParagraph1: 'Nemáte oprávnění pro přístup k této aplikaci.',
      authErrorParagraph2: 'Obraťte se na správce.',
      authErrorParagraph3: 'Nebo odhlášení ze služby Active Directory a zkuste to znovu.',
      pageNotFound: 'Stránka nenalezena',
      pageNotFoundParagraph1: 'Nemůžeme najít tuto stránku',
      back: 'Domovská stránka',
      rotateDevice: 'otočte prosím zařízení.',
    },
    Feedback: {
      error: 'Něco se pokazilo ... Akce se nezdařila.',
      authentication: 'Ověřuji ... Prosím, vyčkejte',
      success: 'Akce byla úspěšně dokončena',
      limitReached: 'Překročen limit.',
      requestHasBeenSentToApprover: 'Žádost byla odeslána schvalovateli',
      noQuestions: 'Žádné otázky zvolené produktové řady.',
      decisionNotSend: 'Rozhodnutí nebylo úspěšně zasláno do SAPu.',
      noLimitForCC: 'Nemáte autorizaci ke schválení této částky.',
      jobCostDoesNotExist:'Náklady úlohy ze systému SAP Úloha neexistuje v databázi PARS',
      materialNumberBrandDoesNotExist: 'Značka čísla materiálu neexistuje.',
      jobIsLocked: 'Úloha je uzamčena.',
      noPicturesAreUploaded: 'Nejsou nahrány žádné obrázky',
      rateIsProvided: 'Hodnocení bylo úspěšně zaregistrováno',
      rateHasToBeDifferent: 'Hodnocení musí být rozdílné od předchozího',
    },
    Status: {
      title: 'Postavení',
      awaitingEquipment: 'čeká na zařízení',
      equipmentReceivedWithDocumentation: 'Zařízení obdrženo s dokumentací',
      jobReleased: 'Práce uvolněna',
      productEvaluation: 'vyhodnocení produkt',
      strippedAndDecontaminated: 'Rozebrán a dekontaminován',
      builtAndTested: 'Vyroben a testován',
      shipped: 'odesláno',
      technicalAndCommercialDecision: 'Technické a obchodní rozhodnutí',
      finalReportReleased: 'Závěrečná zpráva released',
      closed: 'Zavřeno',
      productInvestigation: 'vyšetřování produktu',
      customerHold: 'zákazník hold',
      notStarted: 'Nezačal',
    },
    Roles: {
      RECEIVING: 'provozovatel skladu',
      SERVICE_ENGINEER: 'Servisní technik',
      FAILURE_ANALYSIS_ENGINEER: 'Selhání analýza inženýr',
      SENIOR_FAILURE_ANALYSIS_ENGINEER: 'Senior analýzy poruch inženýr',
      FAILURE_ANALYSIS_MANAGER: 'Selhání manager analýza',
      SERVICE_TECHNOLOGY_CENTER_MANAGER: 'Service technologické centrum manažer',
      QUALITY_MANAGER: 'Manažer kvality',
      SERVICE_TECHNICAL_SUPPORT_TEAM: 'Service technický tým podpory',
      PRODUCT_COMPANY_TECHNICAL_SUPPORT_TEAM: 'Společnost produkt tým technické podpory',
      DIVISION_OR_BUSINESS_AREA: 'Divize nebo obchodní oblast',
      CUSTOMER_CENTER: 'zákaznické centrum',
      CUSTOMER: 'Zákazník',
      CUSTOMER_CENTER_SERVICE_ENGINEER: 'Zákaznické centrum servisní technik',
      SENIOR_CUSTOMER_CENTER_SERVICE_ENGINEER: 'Senior customer center service engineer CS',
      SUPERADMIN: 'superadmin',
      ZONE_LEADER: 'leader Zone',
      QUESTION_ADMIN: 'otázkou admin',
      DISTRIBUTOR: 'Distributor - Dodavatel',
    },
    Permissions: {
      VIEW_JOB: 'pohled práce',
      EDIT_JOB: 'Upravit úkol',
      IMPORT_JOB_FROM_SAP: 'Import úlohy ze systému SAP',
      LEVEL_3_RELEASE_FOR_INVESTIGATION: 'Level 3 propuštění vyšetřování',
      LEVEL_4_RELEASE_FOR_INVESTIGATION: 'Level 4 propuštění vyšetřování',
      GENERATE_AND_DOWNLOAD_REPORT: 'Generovat a stahovat zprávy',
      VIEW_LOG: 'Zobrazit protokol',
      VIEW_CONVERSATION: 'Zobrazení konverzace',
      PARTICIPATE_IN_CONVERSATION: 'Zapojte se do konverzace',
      TAG_INTEREST: 'tag zájem',
      ADD_REMOVE_FROM_TEAM: 'Přidávat a odebírat z týmu',
      CREATE_JOB: 'Vytvořit úkol',
      DELETE_JOB: 'smazat práci',
      REQUEST_DIFFERENT_REPORT_LEVEL: 'Požadovat různou úroveň sestavy',
      APPROVE_DIFFERENT_REPORT_LEVEL: 'Schválit odlišnou úroveň sestavy',
      WARRANTY_DECISION: 'Rozhodnutí o záruce',
      GOODWILL_DECISION: 'Rozhodnutí goodwill',
      LEVEL_1_REPORT_APPROVAL: 'Úroveň schválení 1 zpráva',
      LEVEL_2_REPORT_APPROVAL: 'Úroveň schválení 2 Zpráva',
      LEVEL_3_REPORT_APPROVAL: 'Úroveň schválení 3 Zpráva',
      LEVEL_4_REPORT_APPROVAL: 'Úroveň schválení 4 Zpráva',
      LEVEL_1_REPORT_REOPEN: 'Level 1 report reopen CS',
      LEVEL_2_REPORT_REOPEN: 'Level 2 report reopen CS',
      LEVEL_3_REPORT_REOPEN: 'Level 3 report reopen CS',
      LEVEL_4_REPORT_REOPEN: 'Level 4 report reopen CS',
      REOPEN_REPORT: 'Znovu otevřít zprávu',
      REQUEST_FAILED_PARTS: 'Požadavek se nezdařil díly',
      SHIP_FAILED_PARTS: 'Loď se nepodařilo díly',
      PRINT_INPUT_SHEETS: 'Vstupní tiskových archů',
      ADMINISTRATE_QUESTIONS: 'spravovat dotazy',
      ADMINISTRATE_DATA: 'Spravovat data',
      DOWNLOAD_PICTURES: 'Download pictures CS',
      REQUEST_TECHNICAL_WARRANTY_DECISION: 'Request technical warranty decission CS',
      AMEND_APPROVED_TECHNICAL_DECISION: 'Amend approved technical decision CS',
      AMEND_APPROVED_COMMERCIAL_DECISION: 'Amend approved commercial decision CS',
      ADD_INITIAL_WARRANTY_CODE: 'Add initial warranty code CS',
      RECLASSIFY_TECHNICAL_WARRANTY_CATEGORY: 'Reclassify technical warranty category CS',
      APPROVE_REPORT_LEVEL_4_DOWNGRADE: 'Approve report level 4 downgrade CS',
    },
    Alerts: {
      noAlerts: 'žádné výstrahy',
      healthAndSafetyInformationMissing: 'Zdraví a bezpečnost Informace o chybějící',
      jobNotReleased: 'Job neuvolňuje',
      noRecentStatusChange: 'Žádná nedávná změna stavu',
      noServiceTechnicalSupportInvolvement: 'Zatím není zahrnuta žádná technická podpora služeb',
      noProductCompanyTechnicalSupportInvolvement: 'Dosud nebyla zapojena žádná technická podpora produktové společnosti',
      noTechnicalWarrantyDecision: 'Žádné rozhodnutí technická záruka',
      noCommercialDecision: 'Žádné obchodní rozhodnutí',
      reportNotApproved: 'Zpráva nebyla schválena',
    },
    Actions: {
      ADD_JOB: 'přidané práce',
      IMPORT_JOB: 'Dováženy práce od společnosti SAP',
      DELETE_JOB: 'vypouští práce',
      VERIFY_JOB: 'Ověřená práce',
      SET_PRICE: 'Změněné práce - náklady',
      ADD_TEAM_MEMBER: 'člen týmu z přidané',
      REMOVE_TEAM_MEMBER: 'člen týmu odstraněno',
      REQUEST_REPORT_LEVEL_CHANGE: 'Požadovaná změna hladiny Zpráva',
      APPROVE_REPORT_LEVEL_CHANGE: 'Schválena změna hladiny Zpráva',
      DENY_REPORT_LEVEL_CHANGE: 'Odepřen změna hladiny Zpráva',
      REQUEST_REPORT_APPROVAL: 'Požadované schválení zprávy',
      APPROVE_REPORT_APPROVAL: 'Schválený schválení zprávy',
      DENY_REPORT_APPROVAL: 'Odepřeno schválení zprávy',
      DENY_COMMERCIAL_WARRANTY_DECISION: 'Odmítnuté obchodní záruční rozhodnutí',
      SET_WARRANTY_START_DATE: 'Změněné práce - Záruka datum zahájení',
      SET_WARRANTY_END_DATE: 'Změněné práce - Záruka datum ukončení',
      EQUIPMENT_SERIAL_NUMBER_EDITED: 'Změněné práce - Výrobní číslo zařízení',
      MATERIAL_NUMBER_EDITED: 'Změněné práce - Materiál číslo',
      WORKED_ON_JOB: 'Změněné práce - Update podoba',
      UPLOADED_FILE_ON_JOB: 'Změněné práce - Nahraný soubor',
      REQUEST_TECHNICAL_WARRANTY_DECISION: 'Požadované rozhodnutí technická záruka',
      APPROVE_TECHNICAL_WARRANTY_DECISION: 'Schváleno rozhodnutí technická záruka',
      DENY_TECHNICAL_WARRANTY_DECISION: 'Popíral rozhodnutí technická záruka',
      REQUEST_COMMERCIAL_WARRANTY_DECISION: 'Requested commercial warranty decision',
      APPROVE_COMMERCIAL_WARRANTY_DECISION: 'Schváleno rozhodnutí Komerční záruka',
      NULLIFY_COMMERCIAL_WARRANTY_DECISION: 'Zrušil rozhodnutí Komerční záruka',
      SEND_COMMENT: 'komentář byl přidán',
      REOPEN_REPORT: 'Změněné práce - Znovu zprávu',
      AWAITING_EQUIPMENT_STATUS_SET: 'Změněné Status - čeká na vybavení set',
      AWAITING_EQUIPMENT_STATUS_RESET: 'Změněné status - resetování zařízení Čeká',
      EQUIPMENT_RECEIVED_WITH_DOCUMENTATION_STATUS_SET: 'Změněné status - zařízení receieved s dokumentací sadou',
      EQUIPMENT_RECEIVED_WITH_DOCUMENTATION_STATUS_RESET: 'Změněné status- zařízení receieved s resetem dokumentace',
      JOB_RELEASED_STATUS_SET: 'Změněné status - Job propuštěn set',
      JOB_RELEASED_STATUS_RESET: 'Změněné status - Job uvolněna resetovací',
      PRODUCT_EVALUATION_STATUS_SET: 'Změněné status - Hodnocení produktu set',
      PRODUCT_EVALUATION_STATUS_RESET: 'Změněné status - resetování hodnocení produktu',
      PRODUCT_INVESTIGATION_STATUS_SET: 'Změněné status - Product vyšetřování set',
      PRODUCT_INVESTIGATION_STATUS_RESET: 'resetování vyšetřování produktu - upravil stav',
      STRIPPED_AND_DECONTAMINATED_STATUS_SET: 'Změněné stav - Stripped a dekontaminovány sadu',
      STRIPPED_AND_DECONTAMINATED_STATUS_RESET: 'Změněné stav - Stripped a dekontaminovány resetu',
      BUILT_AND_TESTED_STATUS_SET: 'Změněné stavu - stavět a testovat sadu',
      BUILT_AND_TESTED_STATUS_RESET: 'Změněné status - Build a testovány resetu',
      SHIPPED_STATUS_SET: 'Změněné status - být dodáván set',
      SHIPPED_STATUS_RESET: 'Změněné stav - Posíláme resetu',
      TECHNICAL_AND_COMERCIAL_DECISION_STATUS_SET: 'Změněné status - Technické a obchodní rozhodnutí set',
      TECHNICAL_AND_COMERCIAL_DECISION_STATUS_RESET: 'Změněné status - Technická a resetování obchodní rozhodnutí',
      FINAL_REPORT_RELEASED_STATUS_SET: 'Změněné status - Závěrečná zpráva vydávané sady',
      FINAL_REPORT_RELEASED_STATUS_RESET: 'Změněné status - Závěrečná zpráva vydána resetu',
      CLOSED_STATUS_SET: 'Změněné stav - Closed resetu',
      CLOSED_STATUS_RESET: 'Změněné stav - Closed resetu',
      CUSTOMER_HOLD_STATUS_SET: 'Změněné status - Customer hold set',
      CUSTOMER_HOLD_STATUS_RESET: 'Změněné status - resetování hold Customer',
      REFACTOR_TECHNICAL_WARRANTY_DECISION: 'Upravená kategorie technického rozhodnutí',
      GENERATE_ALERT: 'Varování vygenerováno',
      INITIAL_WARRANTY_CODE_EDITED: 'Počáteční záruční kód byl změněn',
      AMEND_APPROVED_TECHNICAL_DECISION: 'Amended approved technical warranty decision CS',
      AMEND_APPROVED_COMMERCIAL_DECISION: 'Amended approved commercial decision CS',
      DELETE_APPROVED_TECHNICAL_DECISION: 'Deleted aproved technical warranty decision CS',
      DELETE_APPROVED_COMMERCIAL_DECISION: 'Deleted approved commercial decision CS',
      CHOOSE_RELEASE_METHOD: 'Chose release method CS',
    },
    TechnicalWarranty: {
      ACCEPTED: 'přijato',
      DENIED: 'odepřeno',
      AGREE: 'Souhlasit',
      DISAGREE: 'Nesouhlasit',
      MANUFACTURING: 'Výrobní',
      DESIGN: 'Design',
      VENDOR: 'Dodavatel',
      PROCESS: 'Proces',
      INHOUSE_REPAIR: 'STC oprava',
      FIELD_SERVICE_REPAIR: 'Oprava Field service',
      NO_FAULT_FOUND: 'žádná závada nezjištěna',
      WARRANTY_EXPIRED: 'záruka uplynula',
      WARRANTY_EXPIRED_NO_FAULT_FOUND: 'Out of standard warranty period - No fault found',
      WARRANTY_EXPIRED_CUSTOMER_FAULT: 'Out of standard warranty period - Customer fault',
      WARRANTY_EXPIRED_OTHER: 'Out of standard warranty period - Other',
      WARRANTY_EXPIRED_COMPONENT_ISSUE: 'Out of standard warranty period - Component issue (Edwards fault)',
      CUSTOMER_FAULT: 'chyba zákazníka',
      OTHER: 'jiný',
      AGREE_WITH_TECHNICAL_WARRANTY_LOG: 'Souhlasím s technickým rozhodnutím',
      DISAGREE_WITH_TECHNICAL_WARRANTY_LOG: 'Nesouhlasím s technickým rozhodnutím',
      SPARE_PART: 'Spare part (Service Division) CS',
    },
    CommercialWarranty: {
      CONTRACTUAL_AGREEMENT: 'smluvní ujednání',
      GOODWILL_ACCEPTED: 'goodwill přijat',
      CHARGEABLE_TO_CUSTOMER: 'Vyúčtovány zákazníkovi',
      EXTENDED_WARRANTY: 'Prodloužená záruka',
      SERVICE_CONTRACT: 'Smlouva o poskytování služeb',
      OTHER: 'jiný',
      SEMICONDUCTOR: 'Semiconductor',
      SCIENTIFIC: 'Scientific',
      INDUSTRIAL: 'Industrial',
      SEMICONDUCTOR_SERVICE: 'Semiconductor Service',
      VACUUM_TECHNIQUE_SERVICE: 'Vacuum Technique Service',
      SEMICONDUCTOR_CHAMBER_SOLUTIONS: 'Semiconductor Chamber Solutions',
      SEMI_ABATEMENT_AND_INTEGRATED_SYSTEMS: 'Semi Abatement & integrated systems',
      SEMI_ADVANCED_CHEMICAL_MANAGEMENT: 'Semi Advanced Chemical Management',
      SERVICE_CRYOGENICS: 'Service Cryogenics',
      SEMI_DRY_PUMPS: 'Semi Dry Pumps',
      INDUSTRIAL_CUSTOM_DESIGN: 'Industrial custom design',
      INDUSTRIAL_VACUUM: 'Industrial Vacuum',
      SCIENTIFIC_CUSTOM_DESIGN: 'Scientific custom design',
      SEMICON_TURBO_PUMPS: 'Semicon Turbo pumps',
      POLYCOLD: 'Polycold',
    },
    Release: {
      NO_TECHNICAL_TEAM_INVOLVEMENT: 'Žádné technické zapojení tým',
      GOLDENEYE_UPLINK: 'GoldenEye uplink',
      ON_SITE_PRESENCE: 'Na místě přítomnosti',
      RETURN_TO_PRODUCT_COMPANY: 'Návrat do společnosti produkt',
      SEND_BACK_PARTS: 'Pošlete zpět díly',
    },
    Forms: {
      fields: {
        basicInformation: 'Základní informace',
        customerCenter: 'zákaznické centrum',
        serviceTechnologyCenter: 'Service technologické centrum',
        reportLevel: 'úroveň zprávy',
        initialWarrantyCode: 'Počáteční záruční kód',
        technicalDecision: 'Technická rozhodnutí',
        commercialDecision: 'obchodní rozhodnutí',
        price: 'Cena',
        jobStatus: 'Pracovní status',
        reportCompletion: 'dokončení zpráva',
        alerts: 'výstrahy',
        team: 'tým',
        customer: 'Zákazník',
        customerContact: 'Kontakt se zákazníkem',
        jobDetails: 'podrobnosti o zaměstnání',
        jobType: 'Typ práce',
        serviceProduct: 'servis výrobek',
        equipment: 'Zařízení',
        failure: 'Selhání',
        symptom: 'Příznak',
        address: 'Adresa',
        contactPerson: 'Kontaktní osoba',
        email: 'E-mailem',
        phone: 'Telefon',
        customerPurchaseOrderNumber: 'číslo kupní objednávky zákazníka',
        equipmentWarranty: 'Záruka na zařízení',
        serviceWarranty: 'Servisní záruka',
        reportStatus: 'status Report',
        reopen: 'Znovu otevřít',
        releaseJob: 'release práce',
        notifyTeam: 'Notify team CS',
      },
      errors: {
        required: 'Políčko je vyžadováno',
        tel: 'Vložte prosím platné telefonní číslo.',
        email: 'Prosím zadejte platný email.',
        number: 'Pouze čísla jsou povolena',
        alphanumeric: 'Žádné speciální znaky povoleny',
        text: 'Zadejte platnou hodnotu',
        unknown: 'Něco se pokazilo...',
        belowZero: 'Hodnota nemůže být nižší než 0 ° C.',
        uploadFailed: 'Nepodařilo se nahrát',
        maxFileSize: 'Maximální povolená velikost je',
        maxLength: maxLength => `Max ${maxLength} characters allowed`,
        minLength: minLength => `Please enter at least ${minLength} characters`,
      },
    },
    FaultCodes: {
      fallbackDescription: 'Není dostupný popis tohoto kódu',
      jobTypeDescription: {
        'JT001': 'Popis pro typ úlohy JT001',
        'JT002': 'Popis pro typ úlohy JT002',
      },
      faultCodeDescription: {
        'FC001': 'Popis pro typ úlohy FC001',
        'FC002': 'Popis pro typ úlohy FC002',
      },
      symptomCodeDescription: {
        'SC001': 'Popis pro typ úlohy SC001',
        'SC002': 'Popis pro typ úlohy SC002',
      },
    },
    Progress: {
      title: 'Pokrok',
      productReceived: 'produkt obdržen',
      productEvaluation: 'hodnocení produktu',
      stripObservation: 'Strip pozorování',
      technicalInvestigation: 'Technický průzkum',
      conformityTest: 'Test shody',
    },
  },
  Profile: {
    title: 'Profil',
    name: 'název',
    role: 'Role',
    company: 'Společnost',
    rights: 'práva',
    linked: 'Uživatel je spojeno s',
  },
  Jobs: {
    title: 'Pracovní místa',
    filters: 'filtry',
    myJobs: 'Moje pracovní místa',
    otherJobs: 'Ostatní pracovní místa',
    noJobsToDisplay: 'Žádná volná místa k zobrazení.',
    pleaseUseTheSearchBar: "Please use the search bar. CS",
    id: 'ID',
    createdAt: 'vytvořeno',
    status: 'Status',
    customer: 'Zákazník',
    serialProductNumber: 'Sériové číslo',
    materialNumber: 'Materiálové číslo',
    equipmentSerialNumber: 'Sériové číslo',
    customerCenterPlantCode: 'CC',
    serviceTechnologyCenterPlannerGroup: 'STC',
    handledBy: 'vyřizuje',
    reportLevel: 'úroveň zprávy',
    materialDescription: 'Popis materiálu',
    customerName: 'Jméno zákazníka',
    receivedDate: 'Datum obdržení',
    customerCenterName: 'Název CC',
    productReceived: 'produkt obdržen',
    productEvaluation: 'hodnocení produktu',
    stripObservation: 'Strip pozorování',
    technicalInvestigation: 'Technický průzkum',
    conformityTest: 'Test shody',
    workFlow: 'Pracovní postup',
    analysisFlow: 'průtok analýza',
    notificationNumber: 'číslo oznámení',
    serviceOrderNumber: 'Číslo služby objednávka',
  },
  Job: {
    editButton: 'Upravit',
    progress: 'Pokrok',
  },
  Filters: {
    filtersTitle: 'filtry',
    applyButton: 'Aplikovat',
    clearButton: 'Průhledná',
    sorting: 'třídění',
    sortNew: 'třídit nejnovější',
    sortOld: 'třídit nejstarší',
    date: 'datum',
    dateFrom: 'Od',
    dateTo: 'Do',
    reportLevel: 'úroveň zprávy',
    status: 'status',
    customerNumber: 'Zákaznické číslo',
    customerName: 'Jméno zákazníka',
    serviceProductNumber: 'Číslo služby produktu',
    materialNumber: 'číslo materiálu',
    equipmentSerialNumber: 'Výrobní číslo zařízení',
    stcPlannerGroup: 'STC plánovač skupina',
    selectstcPlannerGroup: 'Select STC plánovač skupina',
    CCplant: 'CC závod',
    selectCCplant: 'Select CC závod',
    distributor: 'Distributor - Dodavatel',
    selectDistributor: 'Vyberte Distributor – Vyberte dodavatele',
    failureAnalysisEngineerNotAssigned: 'Nepřiřazeno FAE',
    openedJobs: 'Otevřené úlohy',
    publishedJobs: 'Publikované úlohy',
    pendingMyApproval: 'Čeká na můj souhlas',
    notificationNumber: 'Číslo oznámení',
    unreadMessages: 'Nepřečtené zprávy',
    serviceOrderNumber: 'Číslo služby objednávka',
  },
  AddJob: {
    formSections: {
      title: 'Přidat nový úkol',
      createdAt: 'Datum vzniku',
      button: 'Uložit',
      basicInformation: {
        title: 'Základní informace',
        fieldLabels: {
          equipmentSerialNumber: 'Výrobní číslo zařízení',
          serviceTechnologyCenter: 'Service technologické centrum',
          customerCenter: 'zákaznické centrum',
          reportLevel: 'úroveň zpráva',
          initialWarrantyCode: 'Počáteční záruční kód',
          customerPurchaseOrderNumber: 'číslo kupní objednávky zákazníka',
          responsibleSalesPerson: 'Odpovědné prodeje osoba',
          customerCenterContactName: 'Zákaznické centrum Jméno kontaktu',
          customerCenterContactEmail: 'Zákaznické centrum kontaktní e-mail',
        },
      },
      jobType: {
        title: 'Typ',
        fieldLabels: {
          jobType: 'Typ',
          jobTypeDescription: 'Popis',
        },
      },
      searchMaterialNumber: 'Vyhledat číslo materiálu',
      materialNumber: {
        title: 'číslo materiálu',
        fieldLabels: {
          materialNumber: 'číslo materiálu',
          materialNumberDescription: 'Popis',
        },
      },
      serviceProductNumber: {
        title: 'Číslo služby produktu',
        fieldLabels: {
          serviceProductNumber: 'Číslo služby produktu',
          serviceProductNumberDescription: 'Popis',
        },
      },
      symptomCode: {
        title: 'Příznak kód',
        fieldLabels: {
          scGroups: 'Příznak kód skupiny',
          symptomCode: 'Příznak kód',
          symptomCodeDescription: 'Popis',
        },
      },
      faultCode: {
        title: 'kód poruchy',
        fieldLabels: {
          fcGroups: 'Kód poruchy skupina',
          faultCode: 'kód poruchy',
          faultCodeDescription: 'Popis',
        },
      },
      customerInformation: {
        title: 'Informace o zákazníkovi',
        fieldLabels: {
          customerId: 'zákaznické identifikační číslo',
          customerName: 'název',
          customerAddress: 'Adresa',
          customerContact: 'Kontaktní osoba',
          customerEmail: 'Emailová adresa',
          customerPhone: 'Telefonní číslo',
        },
      },
    },
  },
  ImportJob: {
    title: 'import práce',
    date: 'Datum dovozu',
    importButton: 'Import',
    searchTitle: 'Hledat práci pro import',
    searchSubtitle: 'minimálně 5 znaků, bez počátečních nul',
    searchButton: 'Vyhledávání',
    notificationNumberLabel: 'číslo oznámení',
    serviceOrderNumberLabel: 'Číslo služby objednávka',
    linkTo: 'Odkaz na',
    openJobsFoundForSerNumber: 'Pro toto sériové číslo byly nalezeny otevřené úlohy',
    importJobAsNew: 'Import úlohy jako nové',
    jobIsImportedAlready: 'Úloha je již importována',
    importing: 'Importing in progress... CS',
    linking: 'Linking in progress... CS',
    columns: {
      sourceId: 'Značka',
      notificationNumber: 'Číslo notifikace',
      serviceOrderNumber: 'Číslo servisní objednávky',
      serialNumber: 'Sériové číslo',
      jobTypeDescription: 'Popis',
      customerName: 'Jméno zákazníka',
    },
  },
  SingleJob: {
    title: 'Práce',
    createdAt: 'vytvořen na',
    modifiedAt: 'Naposledy změněno',
    serviceOrderNumber: 'Číslo servisní objednávky',
    notificationNumber: 'Číslo notifikace',
    receivedProduct: 'obdržel produkt',
    productEvaluation: 'hodnocení produktů',
    stripObservation: 'Strip pozorování',
    technicalInvestigation: 'Technické vyšetřování',
    conformityTest: 'Test shody',
    log: 'Log',
    conversation: 'Konverzace',
    noTechPossibilityParagraph1: 'Toto STC nemůže přetestovat tuto pumpu.',
    noTechPossibilityParagraph2: 'Ukončete prácí a přepošlete pumpu do jiného STC.',
    downloadPictures: 'Stáhnout obrázky',
    downloadAllPictures: 'Stáhněte si všechny obrázky',
    downloadPicturesFrom: 'Stahujte obrázky z',
    downloadInProgressPleaseWait: 'Download in progress... Please wait CS',
  },
  JobSummary: {
    title: 'přehled zaměstnání',
    createdAt: 'vytvořen na',
    modifiedAt: 'Naposledy změněno',
    rateTechnicalDecisionTitle: 'Ohodnoťte technické rozhodnutí',
    rateTechnicalDecisionComment: 'Komentář k hodnocení technického rozhodnutí',
    rate: 'hodnotit',
    reclassify: 'Reclassify CS',
    reportLevelDialogTitle: 'úroveň zpráva',
    reportLevelDialogContent: 'Nastavit požadovanou úroveň Zpráva',
    reportLevelDialogInitialWarrantyCodeLabel: 'Počáteční záruční kód',
    approveReportLevelDialogTitle: 'Schválí požadavek na úrovni sestavy',
    technicalWarrantyDialogTitle: 'Navrhovat technické rozhodnutí',
    editTechnicalWarrantyDialogTitle: 'Edit technical decision proposal CS',
    technicalWarrantyDialogContent: 'Rozhodnutí Warranty',
    technicalWarrantyDialogCategory: 'kategorie Warranty',
    technicalWarrantyDialogSIBFieldLabel: 'SIB',
    approveTechnicalWarrantyDialogTitle: 'Schvalovat technické záruční návrh',
    approveTechnicalWarrantyDialogSIBLabel: 'SIB',
    reclassifyTechnicalWarrantyDialogTitle: 'Reklasifikujte kategorii technického rozhodnutí',
    commercialDecisionDialogTitle: 'Udělejte obchodní rozhodnutí',
    commercialDecisionDialogContent: 'Obchodní rozhodnutí',
    commercialDecisionDialogCategory: 'Obchodní kategorie',
    approveCommercialDecisionDialogTitle: 'schvalovat návrh',
    amendTechnicalWarrantyDecisionDialogTitle: 'Amend technical warranty decision CS',
    amendCommercialDecisionDialogTitle: 'Amend commercial decision CS',
    editPriceDialogTitle: 'editovat cena',
    editPriceLabel: 'Upravit',
    releaseJobDialogTitle: 'release práce',
    releaseJobDialogLabel: 'Vyberte způsob',
    proposedDate: 'Navrhované datum',
    reportStatusDialogTitle: 'Navrhněte změnu stavu hlášení',
    reportStatusDialogContent: 'To umožní, aby žádost o schválení zprávy.',
    approveReportStatusDialogContent: 'Jste si jisti, že chcete znovu otevřít tuto práci?',
    approveReportStatusDialogTitle: 'Nahlásit žádost o schválení',
    chooseReleaseJobMethodTitle: 'Vyberte metodu úlohy uvolnění',
    editChosenReleaseJobMethodTitle: 'Upravit vybranou metodu úlohy uvolnění',
    editJobStatusDialogTitle: 'Úpravy stavu úlohy',
    editEquipmentSerialNumberDialogTitle: 'Editovat výrobní číslo',
    editEquipmentSerialNumberDialogFieldLabel: 'Výrobní číslo zařízení',
    editMaterialNumberDialogTitle: 'Číslo editovat materiál',
    editMaterialNumberDialogFieldLabel: 'číslo materiálu',
    editMaterialNumberDialogDescriptionFieldLabel: 'Popis',
    warrantyStartDialogTitle: 'Editovat záruka datum zahájení',
    warrantyStartDateLabel: 'Záruka datum zahájení',
    warrantyEndDialogTitle: 'Upravit datum záruka konec',
    warrantyEndDateLabel: 'Záruka datum ukončení',
    verifyJobDialogTitle: 'ověřit práci',
    verifyJobDialogContent: 'Tato akce bude zámek materiál a zařízení čísla pro editaci. Jste si jisti, že následující údaje jsou správné?',
    materialNumber: 'číslo materiálu',
    equipmentSerialNumber: 'Výrobní číslo zařízení',
    deleteConfirmationDialogTitle: 'potvrzení potřebovalo',
    deleteConfirmationDialogContent: 'Jste si jisti, že chcete smazat tuto práci?',
    teamDialogTitle: 'Přidat člena týmu',
    removeTeamMemberDialogTitle: 'Odebrat člena týmu',
    removeTeamMemberDialogContent: 'Jste si jisti, že chcete odstranit tohoto člena z týmu?',
    technicalDecisionReason: 'Technické rozhodnutí důvod',
    warrantyExpiredSubcategoryLabel: 'Out of standard warranty period - Warranty subcategory',
    decisionReason: 'Rozhodnutí důvod',
    changeReportLevelReason: 'Důvod změny úrovně zprávy',
    commercialDecisionReason: 'Obchodní rozhodnutí důvodem',
    approveReportLevelDialogRequestedLevel: 'Požadovaná úroveň',
    approveReportLevelDialogPreviousLevel: 'Předchozí úroveň',
    approveReportLevelDialogInitialWarrantyCode: 'Počáteční záruční kód',
    initialWarrantyCode: 'Počáteční záruční kód',
    shipToAddress: 'Doručovací adresa',
    partNumbers: 'Čísla dílů',
    failureReason: 'Důvod selhání',
    symptomReason: 'Původ příznaku',
    chooseMethod: 'Vyberte metodu',
    chosenMethod: 'Zvolená metoda',
    serialNumberMissingPleaseAdd: 'Serial number missing, please add. CS',
    deleteImportedJob: 'Delete imported CS',
    deleteImportedJobConfirmationDialogContent: 'Are you sure that you want to fully delete this imported job? CS',
  },
  LogSection: {
    title: 'Log',
    sib: 'SIB',
    initialWarrantyCode: 'Počáteční záruční kód',
  },
  ReportsDialog: {
    title: 'generovat zprávy',
    confirmButton: 'generovat',
    reportFormat: 'formát hlášení',
    reportTemplate: 'zpráva šablona',
  },
  ActionMode: {
    takePicture: 'Vyfotit',
    takeStandardPicture: 'Vezměte standardní obraz',
    takeNonStandardPicture: 'Vezměte nestandardní snímek',
    lastScreenMessage: 'Dosáhli jste na konci tohoto oddílu. Prosím, zavřete toto okno.',
    lastScreenMessageUnsavedAnswers: 'Dosáhli jste konce této sekce. Uložte prosím své odpovědi'
  },
  InputFile: {
    special: 'Nestandardní obrázek',
    upload: 'nahrát',
    uploadStandardPicture: 'Nahrajte standardní obrázek',
    uploadNonStandardPicture: 'Nahrajte nestandardní obrázek',
    commentPicture: 'Komentovat obrázek',
    confirmButtonText: 'Uložit komentář',
    moveFileModal: {
      title: 'Přesunout soubor',
      confirmButtonText: 'Přesunout',
      selectSubsection: 'Vyberte podsekci',
      selectQuestion: 'Vyberte otázku',
    },
  },
  FilePreviewModal: {
    moveFileButtonText: 'Přesunout',
  },
}



// WEBPACK FOOTER //
// ./src/constants/translations/cs.js